module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/pic_2.523097f2-3f153daad8d6146b9d28c0fdfd75497f.png";